// lib/emailCodes.ts — the 6-digit email code flow (docs/plans/viewing-first-onboarding.md, phase 3): Forgot password on
// the login page, and the first password after booking a viewing on the website. All three calls are public.
import { api } from './api';
import type { AuthUser } from '../types/api';

export interface CodeSession { accessToken: string; refreshToken: string; expiresAt: string; user: AuthUser; state: 'OK' | 'PASSWORD_CHANGE_REQUIRED' }

export const emailCodesApi = {
  /** Always { ok: true } — an account with that email is sent a code. */
  request: async (email: string) => (await api.public.post<{ ok: true }>('/auth/code/request', { email })).data,
  /** The code → a 10-minute token for `setPassword`. */
  verify: async (email: string, code: string) => (await api.public.post<{ token: string }>('/auth/code/verify', { email, code })).data,
  /** The token + a new password → signed in (the login payload). */
  setPassword: async (token: string, password: string) => (await api.public.post<CodeSession>('/auth/password/set', { token, password })).data,
};

/** Seconds a "Send a new code" link waits after a code was sent. */
export const RESEND_COOLDOWN_SECONDS = 60;
